import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";

const initialState = {
  allSubServices: [],
  subServices: { subServicesData: [], count: 0 },
  subServiceDetail: {},
};

export const getAllSubServices = createAsyncThunk(
  "subServiceData/getAllSubServices",
  async (payload) => {
    try {
      const response = await allAPI.subServices.getSubServices(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createSubService = createAsyncThunk(
  "subServiceData/createSubService",
  async (payload) => {
    try {
      let pagination = payload.pagination;
      delete payload.pagination;
      const response = await allAPI.subServices.createSubServices(payload);
      if (response.status === 201) {
        return { data: response.data, pagination: pagination };
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createSubServiceMapping = createAsyncThunk(
  "programData/createSubServiceMapping",
  async (payload) => {
    try {
      const response = await allAPI.subServices.createSubServiceMapping(
        payload
      );
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const deleteSubServiceMapping = createAsyncThunk(
  "programData/deleteSubServiceMapping",
  async (payload) => {
    try {
      const response = await allAPI.subServices.deleteSubServiceMapping(
        payload
      );
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);
export const updateSubServiceType = createAsyncThunk(
  "updateSubServiceType",
  async (payload) => {
    try {
      const response = await allAPI.subServices.updateSubServiceType(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);

const subServicesSlice = createSlice({
  name: "subServiceData",
  initialState,
  reducers: {
    setSubService: (state, action) => {
      state.subServiceDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSubServices.pending, (state) => {
        console.log("pending");
      })
      .addCase(getAllSubServices.fulfilled, (state, action) => {
        if (action.payload.subServicesData) {
          state.subServices = action.payload;
          console.log(state.subServices, "response");
        } else {
          state.allSubServices = action.payload;
        }
      })
      .addCase(getAllSubServices.rejected, (state, action) => {
        console.log("rejected", action.error.message);
      })
      .addCase(createSubService.pending, (state) => {
        console.log("pending");
      })
      .addCase(createSubService.fulfilled, (state, action) => {
        if (action.payload.pagination) {
          let currentPage = action.payload.pagination.pageIndex;
          let currentPageSize = action.payload.pagination.pageSize;
          state.subServices.count = state.subServices.count + 1;

          if (currentPage + 1 * currentPageSize > state.subServices.count) {
            state.subServices.subServicesData = [
              ...state.subServices.subServicesData,
              action.payload.data.data,
            ];
          }
        } else {
          state.subServiceDetail = action?.payload?.data.data;
          getAllSubServices();
        }
      })
      .addCase(createSubService.rejected, (state, action) => {
        console.log("rejected", action.error.message);
      });
  },
});

export const { setSubService } = subServicesSlice.actions;

export default subServicesSlice.reducer;
